// import fs from "fs"

const configPath = `${process.cwd()}/siteoneComponents.config.js`

const defaults = {
  gutterSmall: 2,
  gutter: {
    s: 2,
    m: 3,
    l: 4,
  }
}

let config = { ...defaults }
/*if (fs.existsSync(configPath)) {
  const localConfig = require(configPath)
  config = { ...config, ...localConfig }
}*/

export default config